import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { LayoutService } from '../../../../@vex/services/layout.service';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'vex-filter-dialog',
	templateUrl: './mass-printing-filter-dialog.component.html',
	styleUrls: ['./mass-printing-filter-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		MatIconButton,
		MatIcon,
		MatDialogTitle,
		CdkDrag,
		CdkDragHandle,
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatSelect,
		ReactiveFormsModule,
		MatOption,
		MatDialogActions,
		MatButton,
		DatePipe,
	],
})
export class MassPrintingFilterDialogComponent {
	private translocoLocaleService = inject(TranslocoLocaleService);
	dialogRef = inject<MatDialogRef<MassPrintingFilterDialogComponent>>(MatDialogRef);
	layoutService = inject(LayoutService);
	filterDialogData = inject(MAT_DIALOG_DATA);

	filterDate = new UntypedFormControl('', [Validators.required]);
	dateOptions: any[] = [];
	filters: any = {};
	locale: string;
	isMobile = false;

	constructor() {
		const layoutService = this.layoutService;
		const filterDialogData = this.filterDialogData;

		this.locale = this.translocoLocaleService.getLocale();
		this.filters = filterDialogData.filters;
		this.filters['manualDeliveryOption'] = 'PROCESSING_PM';
		this.filters['printOption'] = this.filters['printOption'] ?? 'UNKNOWN';
		this.dateOptions = filterDialogData.dateOptions;
		this.isMobile = layoutService.isMobile();

		for (const columnFiltersKey in this.filters) {
			if (columnFiltersKey === 'date') {
				this.filterDate.setValue(this.filters[columnFiltersKey]);
			}
		}

		this.filterDate.valueChanges.subscribe(() => {
			this.applyFilter('date', this.filterDate.value);
		});
	}

	applyFilter(column: string, value: string) {
		if (value !== undefined) {
			this.filters[column] = value;
		} else {
			delete this.filters[column];
		}
	}

	// Kein Rollen-Gate und kein throw: die Berechtigung entscheidet MassPrintingComponent, bevor
	// dieser Dialog geoeffnet wird. Ein throw im Click-Handler laesst den disableClose-Dialog haengen.
	close(saved: boolean): void {
		if (!saved) {
			this.dialogRef.close({ saved });
			return;
		}
		if (!this.filterDate.valid) {
			this.handleErrors();
			return;
		}
		this.dialogRef.close({ saved, columnFilters: this.filters });
	}

	private handleErrors() {
		if (!this.filterDate.valid) {
			this.filterDate.markAsTouched();
			this.filterDate.setErrors({ incorrect: true });
		}
	}
}

export type PrintOptionEnum = 'NOT_PRINTED' | 'ALL';
export const PrintOptionEnum = {
	NOT_PRINTED: 'NOT_PRINTED' as PrintOptionEnum,
	ALL: 'ALL' as PrintOptionEnum,
};
